// libs
import styled from "@emotion/styled";

// mixins
import { resetButton } from "shared/styles/mixin";

// components
import BaseSearchInput from "shared/components/SearchInput";

export const SearchContainer = styled.div`
    width: 100%;

    & > .sh-container {
        display: flex;
        align-items: center;

        & > .sh-search {
            position: relative;
            flex: 1;

            & > .sh-clear {
                ${resetButton}

                height: 12px;
                width: 20px;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                background-size: contain;
                cursor: pointer;
            }
        }

        & > .sh-cancel {
            display: flex;
            align-items: center;
            height: 30px;
            margin-left: 10px;
            font-size: 0.85rem;
            margin-right: -5px;
            padding: 0 5px;
            border: 0;
            background: #fff;
            cursor: pointer;
            outline: none;
        }
    }
`;

export const SearchInput = styled(BaseSearchInput)`
    border-bottom: 2px solid #000;
    flex: 1;

    & > .input {
        height: 35px;
    }
`;
